'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var detailInCart = document.getElementById('detailInCart');
    var productIdString = window.location.pathname.split('/').filter(function (s) {
        return s;
    }).at(2);

    if (detailInCart && _common2.default.testIntInString(productIdString)) {
        var cart = _common2.default.getCartData();
        var productId = parseInt(productIdString);
        var product = cart.items.find(function (i) {
            return i.id === productId || i.productId === productId;
        });
        detailInCart.textContent = product ? product.amount : 0;
    }
};

var _common = require('../utils/common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/detailUtility.js
// module id = 597
// module chunks = 0